<template>
  <div id="mIndex">
    <Nav />
    <div class="index-banner">
      <div class="top-container">
        <div class="swiper-wrapper">
          <!-- <div class="swiper-slide">
            <router-link to="/ProjectDetail/3/304">
              <img src="../assets/index-t-slide5.png" alt />
              <div class="slide-word">
                <p class="c333">Rich More瑜伽牵引</p>
                <p class="c333">全身肌肉放松释放疲劳</p>
                <p>了解详情</p>
              </div>
            </router-link>
          </div> -->
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/1/109">
              <img src="../assets/index-t-slide4.png" alt />
              <div class="slide-word">
                <p class="c333">P.01抗糖化温感8合1石膏护理</p>
                <p class="c333">高效嫩肤，抗衰抗糖</p>
                <p>了解详情</p>
              </div>
            </router-link>
          </div>
          <div class="swiper-slide">
            <router-link to="/Project/1">
              <img src="../assets/index-t-slide3.png" alt />
              <div class="slide-word">
                <p>每寸肌肤都尽心对待，造就尊贵的护理体验</p>
                <p>唤起你一开始就拥有的美</p>
                <p>探索皮肤管理</p>
              </div>
            </router-link>
          </div>
          <div class="swiper-slide">
            <router-link to="/Project/2">
              <img src="../assets/index-t-slide2.png" alt />
              <div class="slide-word">
                <p>日式传统技艺与科技的结合，改变头皮衰老</p>
                <p>瞬间进入梦乡的温泉护理</p>
                <p>探索头皮管理</p>
              </div>
            </router-link>
          </div>
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/1/101">
              <img src="../assets/index-t-slide1.png" alt />
              <div class="slide-word">
                <p>一颗焕颜的“灯泡”裸肌</p>
                <p>专注肌肤逆龄</p>
                <p>探索以色列黑科技</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="top-pagination"></div>
      </div>
    </div>
    <div class style="height: 388px;">
      <div class="blockTit" style="margin-top: 140px;">项目信息</div>
      <div class="blockText" style="width: 90%;">
        通过引进自日本、德国、西班牙、以色列...的国际先进设备，构建涵盖皮肤、头皮、身体的综合美态管理体系，为您提供完整的美丽方案。
      </div>
      <!-- <div class="blockText">构建涵盖皮肤、头皮、身体的综合美态管理体系，为您提供完整的美丽方案。</div> -->
      <router-link to="/Project/1" class="blockLink">查看全部&gt;</router-link>
    </div>
    <div class="index-banner">
      <div class="mid-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/2/204">
              <img src="../assets/index-m-slide1.jpg" alt />
            </router-link>
            <p>综合改善头皮老化</p>
          </div>
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/1/106">
              <img src="../assets/index-m-slide2.jpg" alt />
            </router-link>
            <p>面部抗老提升</p>
          </div>
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/3/301">
              <img src="../assets/index-m-slide3.jpg" alt />
            </router-link>
            <p>INDIBA身体细胞平衡疗法</p>
          </div>
        </div>
        <div class="mid-pagination"></div>
      </div>
    </div>
    <div class style="padding-top: 200px; height: 800px; background: #f8f9f8;">
      <div class="blockTit" style="margin-top: 0;">会员服务</div>
      <div class="blockText">我们为会员提供广泛的服务，</div>
      <div class="blockText">请享受成为会员所持有的优惠。</div>
      <router-link to="/Member" class="blockBtn">立即探索</router-link>
    </div>
    <!-- <div> -->
    <!-- <router-link to="/Shop"><img src="../assets/index-shop.jpg" alt=""></router-link> -->
    <div class="index-shop">
      <div class="blockTit">查找离您最近的精品店</div>
      <div class="blockText">您目前所处的位置？</div>
      <router-link to="/Shop" class="blockBtn">获取路线</router-link>
    </div>
    <!-- </div> -->
    <div class style="padding-top: 140px; height: 350px;">
      <div class="blockTit" style="margin-top: 0;">关于沙龙</div>
      <div class="blockText" style="width: 90%;">
        FK引领着国内依托先进科技进行各项美态管理的新概念，致力于让美业更有科技。
      </div>
    </div>
    <div class="index-banner">
      <div class="bottom-container" style="padding-bottom: 120px;">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <router-link to="/About/history">
              <img src="../assets/index-b-slide1.jpg" alt />
              <p>FK发展史</p>
            </router-link>
          </div>
          <div class="swiper-slide">
            <router-link to="/About/star">
              <img src="../assets/index-b-slide2.jpg" alt />
              <p>明星会员</p>
            </router-link>
          </div>
          <div class="swiper-slide">
            <router-link to="/About/brand">
              <img src="../assets/index-b-slide3.jpg" alt />
              <p>品牌合作</p>
            </router-link>
          </div>
        </div>
        <div class="bottom-pagination"></div>
      </div>
    </div>
    <div
      class="flexBox"
      style="margin-bottom: 40px; padding-bottom: 80px; height: 480px;"
    >
      <div class="blockText">SHARE</div>
      <img
        src="../assets/index-share-ins.png"
        class="index-share-ins"
        alt
        @click="shareIns = true"
      />
      <img
        src="../assets/index-share-wechat.png"
        class="index-share-wechat"
        alt
        @click="shareWx = true"
      />
    </div>
    <mu-dialog title class="fullImg mob" width="636" :open.sync="shareIns">
      <i class="close" @click="shareIns = false"></i>
      <div class="item">
        <div class="d-title">
          欢迎关注FK，
          <br />了解更多详情
        </div>
        <img src="../assets/pIndex-dialog-ins.png" alt />
      </div>
    </mu-dialog>
    <mu-dialog title class="fullImg mob" width="636" :open.sync="shareWx">
      <i class="close" @click="shareWx = false"></i>
      <div class="item">
        <div class="d-title wx">
          欢迎添加微信，
          <br />了解更多详情
        </div>
        <img src="../assets/pIndex-dialog-wx.png" alt />
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
require("@/utils/swiper.min.js");
import("@/utils/swiper.min.css");
export default {
  name: "mIndex",
  data() {
    return {
      shareIns: false,
      shareWx: false,
    };
  },
  components: {
    Nav,
  },
  computed: {},
  methods: {
    initBanner() {
      let banner = new Swiper(".top-container", {
        // effect: 'fade',
        loop: true,
        // initialSlide: 2,
        speed: 600,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: ".top-pagination",
          renderBullet: function(index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
      });
      // banner.slideNext();
    },
    initMswiper() {
      new Swiper(".mid-container", {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".mid-pagination",
        },
      });
    },
    initBswiper() {
      new Swiper(".bottom-container", {
        loop: true,
        pagination: {
          el: ".bottom-pagination",
        },
      });
    },
  },
  mounted() {
    this.initBanner();
    this.initMswiper();
    this.initBswiper();
  },
};
</script>

<style lang="scss">
#mIndex {
  .top-container {
    .swiper-pagination-bullet {
      width: 100px !important;
    }
  }
}
.index-banner {
  position: relative;
  overflow: hidden;
}
.top-pagination {
  position: absolute;
  bottom: 72px !important;
  text-align: center;
  z-index: 9;

  > span {
    margin: 0 10px !important;
    width: 160px !important;
    height: 2px !important;
    border-radius: 0 !important;
    background: #e1dede;
    opacity: 1;
    outline: 0;
    transition: all 0.5s;

    &.swiper-pagination-bullet-active {
      background: #818181;
    }
  }
}

.mid-container,
.bottom-container {
  padding-bottom: 70px;
  .swiper-slide {
    width: 540px;
    img {
      display: block;
      width: 100%;
    }
    p {
      margin-top: 40px;
      font-size: 28px;
      line-height: 43px;
      color: #555;
      text-align: center;
    }
  }
}

.mid-pagination,
.bottom-pagination {
  margin-top: 40px;
  text-align: center;
  span {
    margin: 0 10px !important;
    width: 10px !important;
    height: 10px !important;
    background: #acacac;
    border-radius: 0 !important;
    transform: rotate(45deg);
    &.swiper-pagination-bullet-active {
      background: #818181;
    }
  }
}

.bottom-container {
  margin: 0 auto;
  width: 540px;
  overflow: hidden;
}

.index-share-ins,
.index-share-wechat {
  display: block;
  margin: 56px auto 0;
  pointer-events: auto !important;
}

.fullImg {
  .mu-dialog {
    max-width: none;
  }
  .mu-dialog-body {
    position: relative;
    padding: 0;
    > img {
      display: block;
      width: 100%;
    }
  }

  &.mob {
    .mu-dialog-body {
      height: 626px;
    }
    .item {
      padding-top: 50px;
      width: 440px;
      > img {
        margin-top: 80px;
      }
      .d-title {
        padding-top: 0;
        padding-left: 60px;
        width: 240px;
        font-size: 24px;
        line-height: 34px;
        background-position: left 5px;
        // &.wx {
        //     width:
        // }
      }
    }
  }
}
#mIndex {
  .top-pagination {
    span {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        // float: left;
        width: 100%;
        height: 100%;
        background: #818181;
        transform: scaleX(0);
        transform-origin: left;
      }
      &.swiper-pagination-bullet-active {
        background: #e1dede !important;
        &::after {
          animation: active 5s linear forwards;
        }
      }
    }
  }
  @keyframes active {
    to {
      transform: scaleX(1);
    }
  }
}
</style>
<style lang="scss" scoped>
.blockTit {
  margin-bottom: 56px;
}
.blockText {
  font-size: 28px;
}
.blockLink {
  margin-top: 56px;
  width: 200px;
  text-align: center;
}
.blockBtn {
  margin-top: 80px;
}
.index-shop {
  padding-top: 200px;
  height: 800px;
  background: url(../assets/index-shop.jpg) top/100% no-repeat;

  .blockTit,
  .blockText {
    color: #fff;
  }
  .blockBtn {
    margin-top: 156px;
    background: #fff;
    &:hover,
    &:active {
      background: #d6caab;
    }
  }
}

.slide-word {
  position: absolute;
  top: 602px;
  left: 0;
  width: 100%;
  > p {
    height: 40px;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    &:nth-child(2) {
      margin-top: 4px;
      font-size: 46px;
      line-height: 66px;
    }
    &:nth-child(3) {
      margin: 70px auto 0;
      width: 450px;
      height: 90px;
      font-size: 28px;
      line-height: 90px;
      color: #000;
      background: rgba(214, 202, 171, 0.8);
    }
  }
}
</style>
